import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import CurrencyConverter from '../CurrencyConverter/CurrencyConverter';
import { getInflatedPrice, getMarketingConfig } from '../../helpers/marketingPriceUtils';

import s from './MarketingPrice.css';

/**
 * MarketingPrice Component
 * 
 * Drop-in replacement for CurrencyConverter that optionally shows:
 * - Struck-through inflated "original" price
 * - Discount badge (-X%)
 * - Real price (bold)
 * 
 * When marketing is disabled in SiteSettings, renders normal CurrencyConverter.
 */
class MarketingPrice extends React.Component {
    static propTypes = {
        amount: PropTypes.number,
        from: PropTypes.string,
        className: PropTypes.string,
        // From Redux
        siteSettingsData: PropTypes.object,
    };

    render() {
        const { amount, from, className, siteSettingsData, ...rest } = this.props;
        const { enabled, markup } = getMarketingConfig(siteSettingsData);

        // If marketing disabled or no valid amount, render standard price
        if (!enabled || !amount || amount <= 0) {
            return (
                <CurrencyConverter
                    amount={amount}
                    from={from}
                    className={className}
                    {...rest}
                />
            );
        }

        const inflatedPrice = getInflatedPrice(amount, markup);

        return (
            <span className={s.marketingPriceWrap}>
                <span className={s.originalPrice}>
                    <CurrencyConverter amount={inflatedPrice} from={from} />
                </span>
                <span className={s.discountBadge}>
                    -{markup}%
                </span>
                <span className={className || s.currentPrice}>
                    <CurrencyConverter amount={amount} from={from} />
                </span>
            </span>
        );
    }
}

const mapState = (state) => ({
    siteSettingsData: state.siteSettings && state.siteSettings.data,
});

export default withStyles(s)(connect(mapState)(MarketingPrice));
